import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BudgetService } from 'src/app/shared/services/budget.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';

@Component({
  selector: 'budget-media-detail',
  templateUrl: './budget-media-detail.component.html',
  styleUrls: ['./budget-media-detail.component.scss']
})
export class BudgetMediaDetailComponent implements OnInit, OnChanges {
    @Output() imageDetailEvent = new EventEmitter<any>();
    @Input('id') id: number;
    @Input('collection') collection: any;
    @Input('type') type: any;

    private license: string;
    private subscription: any[] = [];
    public ackchk = false;

    images: any;
    public categories: any[] = [];
    public currentUser: any;
    public licenses = [
        {
            id: 'Standard',
            name: 'Standard',
            description: 'Limited usage in print, advertising and packaging. Unlimited web distribution',
            price: 4000
        },
        {
            id: 'Enhanced',
            name: 'Enhanced',
            description: 'Unlimited usage in print, advertising, packaging and merchandising. Unlimited web distribution',
            price: 5000
        }
    ];
    collectionSize: any;
    public wish: any;
    cartProduct: any;
    btn: number;
    public videoSize = [
        {
            id: 'Web',
            license: 'Web-240',
            price: 4000
        },
        {
            id: 'SD',
            license: 'SD',
            price: 5000
        }, {
            id: 'HD (720)',
            license: 'HD',
            price: 6000
        }, {
            id: 'HD (1080)',
            license: 'HD',
            price: 7000
        }, {
            id: '4K',
            license: '4K',
            price: 8000
        }
    ];
    public selectedSize: any;
    public categoryId: number;
    imageType = 'all';
    private isAnySizeDownoaded = 0;

    // Sections mirrored from media-detail (image details / related / keywords)
    mediaType = 'images';
    code = '';
    category = 'creative';
    relatedProducts: any[] = [];

    constructor(private appService: BudgetService, private authService: AuthenticationService,
                private toastService: ToastrService, private router: Router) {
        this.authService.currentUser.subscribe(x => this.currentUser = x);

        this.btn = 0;
        this.getCategories();
        this.license = this.licenses[0].id;
    }

    ngOnInit() {
        // First load: ngOnChanges may have fired before the inputs were resolved,
        // so trigger the load here once the inputs are guaranteed to be bound.
        if (this.id && this.collection && !this.images) {
            this.getImageById();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // Skip the very first change (handled by ngOnInit) to avoid a double fetch;
        // reload only when the route inputs actually change afterwards.
        if (changes['id']?.firstChange || changes['collection']?.firstChange) {
            return;
        }
        this.images = undefined;
        this.btn = 0;
        this.license = this.licenses[0].id;
        this.setLicensePrices();
        if (this.id && this.collection) {
            this.getImageById();
        }
    }

    public getCategories() {
    //   console.log('[budget-media-detail] getCategories called');
        // if (this.appService.Data.categories && this.appService.Data.categories.length) {
        //     this.categories = this.appService.Data.categories;
        //     this.setLicensePrices();
        //     console.log('[budget-media-detail] getCategories: using cached categories', this.categories);
        //     return;
        // }
        this.appService.getBudgetCategories().subscribe(data => {
            this.categories = data || [];
            this.appService.Data.categories = this.categories;
            this.setLicensePrices();
            // console.log('[budget-media-detail] getCategories: fetched categories', this.categories);
        });
    }

    private setLicensePrices() {
        const catPrice = (this.categories || []).filter(item => item.id == parseInt(this.collection))[0];
        if (catPrice && catPrice.price) {
            for (let i = 0; i < this.licenses.length; i++) {
                this.licenses[i].price = catPrice.price[this.licenses[i].name] ?? this.licenses[i].price;
            }
        }
    }

    public download(isSubscription: boolean) {
        if (this.images.iseditorial && (this.images.iseditorial == 'yes' || this.images.iseditorial == true) && this.ackchk == false) {
            this.toastService.error('Please acknowledge that this image is for Editorial use only');
        } else {
            this.appService.downloadImage(this.cartProduct, isSubscription).subscribe((data: any) => {
                this.subscription = data;
                this.licenseSubscription();
                const siz = this.images.sizes.filter((item: any) => item.name == this.cartProduct.size)[0];

                const url = siz.download_link;
                if (this.cartProduct.type == 'image') {
                    this.isAnySizeDownoaded = 1;
                }

                const element = document.createElement('a');
                element.setAttribute('href', url);
                element.setAttribute('download', this.cartProduct.id + '');
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);

                if (url != null) {
                    this.btn = 2;
                }
            });
        }
    }

    public reDownloadImage(isSubscription: boolean) {
        if (this.images.iseditorial && (this.images.iseditorial == 'yes' || this.images.iseditorial == true) && this.ackchk == false) {
            this.toastService.error('Please acknowledge that this image is for Editorial use only');
        } else {
            this.appService.reDownloadImageById(this.cartProduct, true).subscribe((data: any) => {
                if (data['data'] && data['data'] != '') {
                    const url = data['data'];

                    const element = document.createElement('a');
                    element.setAttribute('href', url);
                    element.setAttribute('download', this.cartProduct.id + '');
                    element.target = '_blank';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                    this.btn = 2;

                } else {
                    this.toastService.error('Problem in downloading image, Contact sales to resolve issue');
                }
            });
        }
    }


    public addToCart() {
        const product = this.cartProduct;

        if (this.images.iseditorial && (this.images.iseditorial == 'yes' || this.images.iseditorial == true) && this.ackchk == false) {
            this.toastService.error('Please acknowledge that this image is for Editorial use only');
            return;
        }

        if (this.currentUser && product.price > 0) {
            const currentProduct = this.appService.Data.cartList.filter((item: any) => item.id == product.id)[0];
            if (currentProduct) {
                this.toastService.error('Image already exist in your cart');
                return;
            }
            this.addToCartApi(product);
        } else {
            this.changeSize(this.selectedSize);
            this.toastService.error('Please sign-in to Purchase.');
        }
    }

    private addToCartApi(product: any) {
        this.appService.addToCartListDB(JSON.stringify(product), this.currentUser.customers_id).subscribe(data => {
            if (data.statusCode === 200) {
                this.appService.addToCart(data.data.imagesArray, data.data.total_price, data.data.total_item);
                let title = 'You Desire We Deliver! Added Your Favourtie ' + this.images.type + ' To The Cart.';
                if (this.images.type == 'video' || this.images.type == 'Video') {
                    title = 'Added Your Lovely Video Pick To The Cart';
                }
                this.toastService.success(title);
                // this.router.navigate(['/cart']);
            } else {
                this.toastService.error('Error in adding product to the cart');
            }
        });
    }

    public getImageById() {
        this.mediaType = (this.type == 'video' || this.type == 'videos') ? 'videos' : 'images';
        this.type = this.mediaType == 'videos' ? 'video' : 'image';
        this.appService.getImageById(this.id, this.collection, this.type).subscribe(data => {
            if (!data || (data.error && data.error != '')) {
                this.images = data;
            } else if (!data.sizes || !data.sizes.length) {
                // Valid response but no sizes: keep it visible but skip size-dependent processing.
                this.images = data;
            } else {
                this.images = data;

                this.selectedSize = this.images.sizes[(this.images.sizes.length - 1)];
                this.images.model = this.images.model + '';
                this.images.property = this.images.property + '';

                this.images.sizes.reverse();

                if (this.images.model == 'true' || this.images.model == '1') {
                    this.images.model = 'Yes';
                }
                if (this.images.model == 'false' || this.images.model == '0') {
                    this.images.model = 'No';
                }
                if (this.images.property == 'true' || this.images.property == '1') {
                    this.images.property = 'Yes';
                }
                if (this.images.property == 'false' || this.images.property == '0') {
                    this.images.property = 'No';
                }
                const videoCatPrice = (this.categories || []).filter(item => item.id == parseInt(this.collection))[0];
                if (this.images.type == 'video') {
                    this.images.sizes.map((obj: any) => {
                        obj.price = videoCatPrice?.price?.[obj.name] ?? obj.price;
                        return obj;
                    });
                } else {
                    this.images.type = 'image';
                }

                if (this.images.type == 'video') {
                    this.imageType = 'videos';
                }

                this.code = this.images.author;
                this.category = this.images.iseditorial && (this.images.iseditorial == 'yes' || this.images.iseditorial == true)
                    ? 'editorial' : 'creative';

                this.getSubscriptionDetail();
                this.getRelatedProducts();
                this.cartProduct = Object.assign({
                    id: data.id,
                    filename: data.filename,
                    thumbnail: data.thumbnail,
                    license: data.license,
                    collection: data.collection,
                    size: data.sizes[data.sizes.length - 1].name,
                    price: data.sizes[data.sizes.length - 1].price,
                    type: data.type ? data.type : 'image',
                    caption: data.caption,
                    category: this.categoryId == 1 ? 'creative' : 'editorial'
                });

                this.imageDetailEvent.emit({
                    images: this.images,
                    cartProduct: this.cartProduct
                });


                this.wish = Object.assign({}, this.images);
                this.wish.id = this.images.filename;
                this.wish.filename = this.images.id + '';
            }
        }, (err: any) => {
            console.error('[budget-media-detail] getImageById failed', err);
            this.toastService.error('Unable to load this media. Please try again.');
        });

    }

    public getRelatedProducts() {
        this.relatedProducts = [];
        if (!this.images?.caption) {
            return;
        }
        this.appService.getImages(this.images.caption, 10, 1, '', true).subscribe((result: any) => {
            this.relatedProducts = (result?.results || []).map((obj: any) => {
                obj.category = this.category;
                return obj;
            });
        }, (err: any) => {
            console.error('[budget-media-detail] getRelatedProducts failed', err);
        });
    }

    public changeSize(size: any) {
        if (!size) {
            return;
        }
        this.selectedSize = size;
        this.collectionSize = (this.appService.Data.categories || [])
            .filter((item: any) => item.id == parseInt(this.collection))[0];
        this.cartProduct.size = size.name;
        if (this.cartProduct.type == 'video') {
            if (size.name == 'Web') {
                this.license = 'Web-240';
            }
            if (size.name == 'SD') {
                this.license = 'SD';
            }
            if (size.name == 'HD (1080)') {
                this.license = 'HD';
            }
            if (size.name == 'HD (720)') {
                this.license = 'HD';
            }
            if (size.name == '4K') {
                this.license = '4K';
            }
        }
        this.cartProduct.usage = this.license;
        if (size.price != null && size.price > 0) {
            this.cartProduct.price = size.price;
        } else {
            this.cartProduct.price = this.collectionSize?.price?.[this.license] ?? 0;
        }
        this.btn = (size.is_downloaded || this.isAnySizeDownoaded == 1) ? 2 : (size.subscription > 0 ? 1 : 0);
    }

    public selectSize(value: string) {
        const size = this.images.sizes.filter((item: any) => item.name == value)[0];
        this.changeSize(size);
    }

    public changeLicense(value: string) {
        this.license = value;
        this.licenseSubscription();
    }

    public getSubscriptionDetail() {
        if (this.currentUser) {
            this.appService.getSubscriptionDetail(this.images.collection, this.images.id, this.images.license, this.images.type).subscribe(data => {
                this.subscription = data;
                this.licenseSubscription();
            });
        }
    }

    private licenseSubscription() {
        if (this.images.type == 'video') {
            this.images.sizes.forEach((obj: any) => {
                if (obj.name == 'Web') {
                    this.license = 'Web-240';
                }
                if (obj.name == 'SD') {
                    this.license = 'SD';
                }
                if (obj.name == 'HD (1080)') {
                    this.license = 'HD';
                }
                if (obj.name == 'HD (720)') {
                    this.license = 'HD';
                }
                if (obj.name == '4K') {
                    this.license = '4K';
                }
                const subFilter = this.subscription.filter((item: any) => item.name == this.license)[0];
                if (!subFilter) {
                    return;
                }
                const siz = subFilter.size.filter((item: any) => item.name == obj.name)[0];
                obj.subscription = subFilter.subscription;
                obj.download_link = siz?.download_link;
                obj.is_downloaded = siz?.is_downloaded;
            });

        } else {
            this.isAnySizeDownoaded = 0;
            const subFilter = this.subscription.filter((item: any) => item.name == this.license)[0];
            if (subFilter) {
                this.images.sizes.forEach((obj: any) => {
                    const siz = subFilter.size.filter((item: any) => item.name == obj.name)[0];
                    obj.subscription = subFilter.subscription;
                    obj.download_link = siz?.download_link;
                    obj.is_downloaded = siz?.is_downloaded;
                    if (obj.is_downloaded) {
                        this.isAnySizeDownoaded = 1;
                    }
                });
            }
        }

        this.changeSize(this.selectedSize);
    }


    chkboxEvent(checked: boolean) {
        this.ackchk = checked;
    }
}
